module.exports = __webpack_public_path__ + "img/黄金邮轮详情.c9b856f8.jpg";